// extracted by mini-css-extract-plugin
export default {"top":"style_top__xrRIP","profile":"style_profile__ARVh8","image":"style_image__9MZW+","name":"style_name__yhqFS","Shouts":"style_Shouts__HxcbX"};